export default __webpack_public_path__ + "static/media/electric-meter-wiring.a83183f4.png";